import { INK, MOTION } from "../../../theme/tokens";

/** The disclosure chevron: turns over when open, reduced-motion safe. */
export const chevronSx = (open: boolean) => ({
	color: INK.MUTED,
	flexShrink: 0,
	transform: open ? "rotate(180deg)" : "rotate(0deg)",
	transition: `transform ${MOTION.DURATION.CONTROL}ms ${MOTION.EASE_OUT}`,
	"@media (prefers-reduced-motion: reduce)": { transition: "none" },
});
